import React, { createContext, useState, useEffect, useContext } from 'react';
import { getProfile } from '../components/Service/UserService';
import Cookies from 'js-cookie';

const ProfileContext = createContext();

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState(null);
    const [alertBalance, setAlertBalance] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            const token = Cookies.get('Token'); // Kiểm tra token
            if (token) {
                try {
                    const response = await getProfile();
                    setProfile(response?.user || {});
                    setAlertBalance(response?.alertBalance || {});
                    localStorage.setItem('Balance', response?.user?.balance);

                } catch (error) {
                    Cookies.remove('Token');
                }
            }
            setLoading(false);
        };
        fetchProfile();
    }, []);

    return (
        <ProfileContext.Provider value={{ profile, alertBalance, loading, setProfile, setAlertBalance }}>
            {children}
        </ProfileContext.Provider>
    );
};
